import React from 'react';
import { useStore } from '../../store/useStore';
import { useLocation, Link } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Building2, 
  BarChart2, 
  Settings,
  Shield,
  ListTodo
} from 'lucide-react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
import { isExecutive } from '../../utils/auth';

export const Sidebar: React.FC = () => {
  const currentUser = useStore((state) => state.currentUser);
  const location = useLocation();

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', href: '/' },
    { icon: Building2, label: 'Departments', href: '/departments' },
    { icon: ListTodo, label: 'My Tasks', href: '/my-tasks' },
    ...(isExecutive(currentUser?.role || 'EMPLOYEE') ? [
      { icon: BarChart2, label: 'Analytics', href: '/analytics' },
      { icon: Shield, label: 'Admin Panel', href: '/admin' }
    ] : []),
    { icon: Settings, label: 'Settings', href: '/settings' },
  ];

  return (
    <aside className="fixed left-0 w-64 h-screen bg-white border-r border-gray-200 pt-20">
      <nav className="p-4">
        <ul className="space-y-2">
          {menuItems.map((item, index) => (
            <motion.li
              key={item.label}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Link
                to={item.href}
                className={clsx(
                  'flex items-center space-x-3 px-4 py-2.5 rounded-lg transition-colors',
                  location.pathname === item.href
                    ? 'bg-emerald-50 text-emerald-700'
                    : 'text-gray-700 hover:bg-gray-50'
                )}
              >
                <item.icon className="w-5 h-5" />
                <span className="font-medium">{item.label}</span>
              </Link>
            </motion.li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}